var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { consume } from '@lit/context';
import { AuthenticationState, authenticationContext, } from '@frontend_zz/web-component-contexts/Authentication/AuthenticationContext.js';
// Mixins
import { BaseElement } from '@frontend_zz/base-element/BaseElement.js';
// Components
import { Button } from '@frontend_zz/button/Button.js';
import { Surface } from '@frontend_zz/surface/Surface.js';
import { AppBar } from '@frontend_zz/app-bar/AppBar.js';
// Styling
import styles from './NavigationOverflowMenu.css.js';
// Data
import content from './Navigation.content.json';
export class NavigationOverflowMenu extends BaseElement {
    constructor() {
        super(...arguments);
        /**
         * The open state of the overflow menu
         */
        this.isOpen = false;
        /**
         * The title to display in the app bar that is used on mobile
         */
        this.appBarTitle = '';
        this.isAuthenticated = false;
        this.authenticationContext = new AuthenticationState();
        this.render = () => {
            const { isOpen, appBarTitle, isMobile } = this;
            const onClick = (_event) => {
                this.dispatchEvent(new Event('dismiss'));
            };
            const onLogoutClick = (_event) => {
                this.dispatchEvent(new Event('logout', {
                    composed: true,
                    bubbles: true,
                }));
            };
            const renderAppBar = () => {
                const { authenticationContext: { isAuthenticated }, } = this;
                return html `
                <zz-app-bar slot="top" title=${appBarTitle}>
                    <zz-button
                        @click=${onClick}
                        slot="left-navigation"
                        variant="icon-only"
                        icon="close"
                        aria-label=${content.overflowCloseLabel}
                    >
                    </zz-button>
                    ${isAuthenticated &&
                    html `
                        <zz-button
                            @click=${onLogoutClick}
                            slot="right-navigation"
                            variant="text"
                            icon="logout"
                            icon-position="right"
                        >
                            ${content.logout}
                        </zz-button>
                    `}
                </zz-app-bar>
            `;
            };
            return html `
            <zz-surface class="outer-wrapper" variant=${isMobile ? 'none' : 'floating'} aria-hidden=${!isOpen}>
                <div class="inner-wrapper">
                    ${when(isMobile, renderAppBar)}
                    <slot></slot>
                </div>
            </zz-surface>
        `;
        };
    }
    static get styles() {
        return [styles];
    }
    static get scopedElements() {
        return {
            'zz-button': Button,
            'zz-surface': Surface,
            'zz-app-bar': AppBar,
        };
    }
}
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'is-open' })
], NavigationOverflowMenu.prototype, "isOpen", void 0);
__decorate([
    property({ reflect: true, attribute: 'app-bar-title' })
], NavigationOverflowMenu.prototype, "appBarTitle", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'is-authenticated' })
], NavigationOverflowMenu.prototype, "isAuthenticated", void 0);
__decorate([
    consume({ context: authenticationContext })
], NavigationOverflowMenu.prototype, "authenticationContext", void 0);
